/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */
import React from 'react';

import SummaryLayout from './SummaryLayout';

const MainLayout = () => {
  return <div className="nav-container">
    <SummaryLayout />
  </div>;
};
export default MainLayout;
